import { CloseOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@apollo/client';
import {
  ChannelTag,
  CREATE_CHANNEL_TAG,
  DELETE_CHANNEL_TAG,
  GET_CHANNEL_TAGS,
} from '@frontend/data-access';
import { Button, Input, Popconfirm, Spin } from 'antd';
import { useState } from 'react';
import { TabHeader } from '../components';
import useTranslation from 'next-translate/useTranslation';

function IdeaTagSettings() {
  const { t } = useTranslation('common');
  const [inputName, setInputName] = useState<string>();
  const { data, loading } = useQuery<{
    channelTags: ChannelTag[];
  }>(GET_CHANNEL_TAGS);

  const [createTag, { loading: createLoading }] =
    useMutation(CREATE_CHANNEL_TAG);
  const [deleteTag, { loading: deleteLoading }] =
    useMutation(DELETE_CHANNEL_TAG);

  const handleFinish = () => {
    createTag({
      variables: {
        name: inputName,
      },
      refetchQueries: [GET_CHANNEL_TAGS],
    });
    setInputName(undefined);
  };

  const deleteTagHandler = (id: string) => {
    deleteTag({
      variables: {
        id,
      },
      refetchQueries: [GET_CHANNEL_TAGS],
    });
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <Spin />
      </div>
    );
  }
  return (
    <div className="space-y-4">
      <TabHeader title={t('idea_tags')} description={t('added_idea_tags')} />
      <div className="flex gap-2 items-center">
        <Input
          data-test="tag-name"
          placeholder={t('enter_tag_name')}
          value={inputName}
          onChange={(e) => setInputName(e.target.value)}
        />
        <Button
          shape="round"
          data-test="tag-add-btn"
          disabled={!inputName}
          loading={createLoading}
          onClick={handleFinish}
        >
          {t('add')}
        </Button>
      </div>
      <div className="flex flex-wrap gap-2 items-center" data-test="tag-list">
        {data?.channelTags.map((item) => (
          <div
            key={item.id}
            className="bg-gray-200 px-3 py-1 rounded-full text-xs text-gray-900 space-x-2"
          >
            <span>{item.name}</span>
            <Popconfirm
              title={t('confirm_delete_tag')}
              onConfirm={() => deleteTagHandler(item.id)}
              okButtonProps={{ loading: deleteLoading }}
              okText={t('yes')}
              cancelText={t('no')}
            >
              <span className="text-gray-700 cursor-pointer">
                <CloseOutlined />
              </span>
            </Popconfirm>
          </div>
        ))}
      </div>
    </div>
  );
}

export default IdeaTagSettings;
